import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@/store/hooks';
import { dataTableInteraction, loadCachedResults } from '@/actions';
import css from '@/css/module/new-world.css';
import DataTableHeaders from '@/containers/DataTableHeaders';
import flex from '@/css/module/flex.css';
import QueryTimer from '@/components/QueryTimer';
import { formatTimestamp } from '@/util/helpers/time-helpers';
import { selectQueryStartTime } from '@/features/query-builder/queryBuilderSlice';
import { useHeadings_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { useDrilldownContext } from '../context';

export const Loading: React.FC<any> = ({ isRoot, className }) => {
  const dispatch = useAppDispatch();
  const headings = useHeadings_LEGACY();
  const cachedTime = useSelector((s: any) => s.views.cachedTime);
  const timerStart = useSelector(selectQueryStartTime);

  const headerRef = useDrilldownContext();

  const [headerHeight, setHeaderHeight] = React.useState(0);
  const loadCacheResultsRef = React.useRef(null);

  // if headers have loaded, calculate height of headers (sometimes they have scrollbars and sometimes not). Value is used to set margin-top of non-sticky table headers (that appear underneath).
  React.useEffect(() => {
    const headerRefHeight = headerRef?.current?.clientHeight ?? 0;
    if (headerRefHeight !== headerHeight) {
      setHeaderHeight(headerRefHeight);
    }
  }, [headings]);

  const handleLoadCachedResults = (e: React.MouseEvent) => {
    e.preventDefault();
    // @ts-expect-error: TODO: get rid of jQuery.
    $(loadCacheResultsRef.current).replaceWith(
      '<div class="margin-top-30">Loading cached...</div>',
    );
    dispatch(loadCachedResults());
  };

  const handleInteraction = (props: unknown) =>
    dispatch(dataTableInteraction(props));

  const newWorldStyle = !className.includes('expanded-cell')
    ? { marginTop: `-${headerHeight}px` }
    : {};

  // in newworld (excluding drilldown) add loader class (positioned absolute relative to tablecontainer)
  const loaderClass = isRoot ? css.loaderContainer : 'margin-top-20 ';

  return (
    <table className={className} style={newWorldStyle}>
      <tbody>
        {!headings || !isRoot ? null : (
          <DataTableHeaders
            key={`dtHeader${0}`}
            rowIndex={0}
            headings={headings}
            hasOptions
          />
        )}
      </tbody>
      <tfoot>
        <tr>
          <td className="no-border">&nbsp;</td>
          <td
            className="no-border"
            colSpan={!headings || headings.length > 4 ? 4 : headings.length}
          >
            <div className={loaderClass}>
              <div className={`${flex.column} ${flex.alignItemsCenter}`}>
                <div className="margin-top-10">
                  <QueryTimer
                    timerStart={timerStart}
                    onInteraction={isRoot ? handleInteraction : undefined}
                  />
                  {!cachedTime || !isRoot ? null : (
                    <a
                      className="load-cached-results"
                      href="#"
                      onClick={handleLoadCachedResults}
                      ref={loadCacheResultsRef}
                    >
                      {' '}
                      Load cached results (from {formatTimestamp(cachedTime)})
                    </a>
                  )}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};
